import styles from './CustomPieChart.module.css';
import { PieChart, Pie, Cell, ResponsiveContainer, Sector } from 'recharts';

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  payload,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 25;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill={payload.color}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      style={{ fontWeight: 'bold', fontSize: '14px' }}
    >
      {payload.label}
    </text>
  );
};

const CustomPieChart = ({ data, colors }) => {
  const pieData = data.map((item, index) => ({
    ...item,
    color: colors[index % colors.length],
  }));

  return (
    <div className={styles.PieChartContainer}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            innerRadius={45}
            outerRadius={60}
            dataKey="value"
            labelLine={true}
            label={renderCustomizedLabel}
            startAngle={90}
            endAngle={-270}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomPieChart;
